var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"head"},[_c('div',{staticClass:"head-layout"},[_c('img',{attrs:{"src":"https://oss.cmef.com.cn/cloudExhibition/imgs/202103/338d8c90612041e4b6059d71dd8504a8.jpg"}}),_c('span',{staticStyle:{"color":"#fff","font-size":"26px","margin-left":"10px"}},[_vm._v(_vm._s(_vm.name))])])]),_c('div',{staticClass:"layout"},[_c('div',{staticStyle:{"min-height":"80px"}},[_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"header-tool-title"},[_vm._v("证件导入/"+_vm._s(_vm.bageType))]),_c('div',{staticClass:"back",on:{"click":_vm.back}},[_vm._v("返回首页")])])])]),_c('div',{staticClass:"body"},[(_vm.BadgeId != 3)?[_c('Table',{attrs:{"border":false,"columns":_vm.columns1,"data":_vm.list,"disabled-hover":false,"loading":_vm.loading},scopedSlots:_vm._u([{key:"badgeType",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(row.deExCardDown.badgeType))]}},{key:"companyName",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(row.deExCardDown.companyName))]}},{key:"boothCode",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(row.deExCardDown.boothCode))]}},{key:"firstName",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(row.deExCardDown.firstName))]}},{key:"phone",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(row.deExCardDown.tel))]}},{key:"email",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(row.deExCardDown.email))]}},{key:"jobTitle",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(row.deExCardDown.jobTitle))]}},{key:"importResultState",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(row.importResultState))]}},{key:"importResultMess",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(row.importResultMess))]}}],null,false,3173024499)})]:[_c('Table',{attrs:{"border":false,"columns":_vm.columns,"data":_vm.list,"disabled-hover":false,"loading":_vm.loading},scopedSlots:_vm._u([{key:"badgeType",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(row.deExCardDown.badgeType))]}},{key:"companyName",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(row.deExCardDown.companyName))]}},{key:"boothCode",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(row.deExCardDown.boothCode))]}},{key:"firstName",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(row.deExCardDown.firstName))]}},{key:"phone",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(row.deExCardDown.tel))]}},{key:"email",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(row.deExCardDown.email))]}},{key:"jobTitle",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(row.deExCardDown.jobTitle))]}},{key:"country",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(row.deExCardDown.country))]}},{key:"department",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(row.deExCardDown.department))]}},{key:"importResultState",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(row.importResultState))]}},{key:"importResultMess",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(row.importResultMess))]}}])})]],2)])}
var staticRenderFns = []

export { render, staticRenderFns }